<template>
    <section class="page-header">
        <img :src="logo" />
        <div class="header-link" :class="{ homeHeader: $route.name === 'home' }">
            <router-link :class="{activeH: $route.path == '/home'}" to="/home">首页</router-link>
            <router-link :class="{active: $route.path == '/case'}" to="/case">社区精选</router-link>
            <a target="_blank" href="http://b.meitouwang.cn/user/login">医院入驻</a>
            <router-link :class="{active: $route.path == '/about'}" to="/about">关于我们</router-link>
        </div>
        <div class="page-header-m">
            <div class="header-control" @click="show = true">
                <svg v-if="$route.path=='/home'" t="1567174113806" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2262" width="200" height="200"><path d="M106.666667 192a21.333333 21.333333 0 1 0 0 42.666667h85.333333a21.333333 21.333333 0 0 0 0-42.666667H106.666667z m0 298.666667a21.333333 21.333333 0 0 0 0 42.666666h85.333333a21.333333 21.333333 0 0 0 0-42.666666H106.666667z m0 298.666666a21.333333 21.333333 0 0 0 0 42.666667h85.333333a21.333333 21.333333 0 0 0 0-42.666667H106.666667zM320 192a21.333333 21.333333 0 0 0 0 42.666667h597.333333a21.333333 21.333333 0 0 0 0-42.666667H320z m0 298.666667a21.333333 21.333333 0 0 0 0 42.666666h597.333333a21.333333 21.333333 0 0 0 0-42.666666H320z m0 298.666666a21.333333 21.333333 0 0 0 0 42.666667h597.333333a21.333333 21.333333 0 0 0 0-42.666667H320z" fill="#ffffff" p-id="2263"></path></svg>
                <svg v-else t="1567174113806" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2262" width="200" height="200"><path d="M106.666667 192a21.333333 21.333333 0 1 0 0 42.666667h85.333333a21.333333 21.333333 0 0 0 0-42.666667H106.666667z m0 298.666667a21.333333 21.333333 0 0 0 0 42.666666h85.333333a21.333333 21.333333 0 0 0 0-42.666666H106.666667z m0 298.666666a21.333333 21.333333 0 0 0 0 42.666667h85.333333a21.333333 21.333333 0 0 0 0-42.666667H106.666667zM320 192a21.333333 21.333333 0 0 0 0 42.666667h597.333333a21.333333 21.333333 0 0 0 0-42.666667H320z m0 298.666667a21.333333 21.333333 0 0 0 0 42.666666h597.333333a21.333333 21.333333 0 0 0 0-42.666666H320z m0 298.666666a21.333333 21.333333 0 0 0 0 42.666667h597.333333a21.333333 21.333333 0 0 0 0-42.666667H320z" fill="#3D3D3D" p-id="2263"></path></svg>
            </div>
            <div class="nav-wrapper" v-show="show">
                <div class="m-nav-header">
                    <img :src="require('@/assets/logo.png')" />
                    <Icon @click="show = false" type="md-close" />
                </div>
                <nav>
                    <router-link :class="{mActive: $route.path == '/home'}" @click.native="show = false" to="/home">首页</router-link>
                    <router-link :class="{mActive: $route.path == '/case'}" @click.native="show = false" to="/case">社区精选</router-link>
                    <a target="_blank" href="http://b.meitouwang.cn/user/login">医院入驻</a>
                    <router-link :class="{mActive: $route.path == '/about'}" @click.native="show = false" to="/about">关于我们</router-link>
                </nav>
            </div>
        </div>
    </section>
</template>
<script>
import mulu from '@/assets/mulu.svg'

export default {
    components: {
        mulu
    },
    data() {
        return {
            show: false
        }
    },
    computed: {
        logo() {
            return this.$route.name === 'home' ? require('@/assets/home_logo.png') : require('@/assets/logo.png')
        }
    }
}
</script>
<style lang="less" scoped>
.page-header-m {
    display: none;
}
.page-header {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    padding: 25px 76px;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    box-shadow:0px 1px 0px 0px rgba(217,217,217,1);
    img {
        width: 130px;
        height: 26px;
    }
    a {
        color: #000;
        margin-left: 94px;
        font-size: 16px;
        padding-bottom: 4px;
        &.active {
            border-bottom: 1px solid #333;
        }
    }
    .homeHeader {
        a {
            color: #fff;
            padding-bottom: 4px;
            &.activeH {
                border-bottom: 1px solid #fff;
            }
        }
    }
}
@media (max-width: 710px) {
    .page-header {
        padding: 22px 25px;
        box-shadow: none;
        .page-header-m {
            display: block;
            .nav-wrapper {
                position: fixed;
                left: 0;
                top: 0;
                width: 100vw;
                height: 100vh;
                background: #fff;
                z-index: 1000;
                a {
                    display: block;
                    text-align: center;
                    margin: 0;
                    margin-bottom: 50px;
                    &.mActive {
                        color: #333333;
                        font-size: 26px;
                        border-bottom: 1px solid #333333;
                    }
                }
                nav {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    padding: 32px;
                    a {
                        color: #666666;
                    }
                }
            }
        }
    }
    .header-link {
        display: none;
    }
    .header-control {
        width: 40px;
        height: 25px;
        // border: 1px solid red;
        .icon {
            width: 100%;
            height: 100%;
        }
        // i {
        //     display: block;
        //     width: 100%;
        //     border: 1px solid #fff;
        //     margin-bottom: 5px;
        // }
    }
    .m-nav-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 22px 32px;
        i {
            font-size: 22px;
        }
    }
}

</style>
